import {CampaignLogicState, SocialCampaignIdentitiesState} from './campaignLogic.types';
import {CampaignTreeType} from 'common/src/modules/campaigns/campaigns.types';

const SOCIAL_CAMPAIGN_IDENTITIES_INITIAL_STATE: SocialCampaignIdentitiesState = {
  facebook: {
    facebookPageOptions: null,
    facebookPageOptionsLoading: false,
    instagramAccountOptions: null,
    instagramAccountOptionsLoading: false,
    facebookPixelOptions: null,
    facebookPixelOptionsLoading: false,
  },
  tiktok: {
    tiktokIdentityOptions: null,
    tiktokIdentityOptionsLoading: false,
    tiktokPixelOptions: null,
    tiktokPixelOptionsLoading: false,
  },
  youtube: {
    youtubeChannelOptions: null,
    youtubeChannelOptionsLoading: false,
  },
  snapchat: {
    snapchatPublicProfileOptions: null,
    snapchatPublicProfileOptionsLoading: false,
  },
  mockSocial: {
    mockSocialIdentityOptions: null,
    mockSocialIdentityOptionsLoading: false,
    mockSocialPixelOptions: null,
    mockSocialPixelOptionsLoading: false,
  },
};

const campaignLogicInitialState: CampaignLogicState = {
  selectedNode: null,
  nodes: {
    [CampaignTreeType.Concept]: {},
    [CampaignTreeType.Campaign]: {},
  },
  nodesByZIndexOrder: {
    [CampaignTreeType.Concept]: [],
    [CampaignTreeType.Campaign]: [],
  },
  nextNodeId: 0,
  nodesWithDisabledHideOutputButton: {},
  hiddenNodeConnectors: [],
  shouldAutoArrange: false,
  socialCampaignIdentities: SOCIAL_CAMPAIGN_IDENTITIES_INITIAL_STATE,
};

const CAMPAIGN_LOGIC_SLICE_NAME = 'campaignLogic';

export {
  campaignLogicInitialState,
  CAMPAIGN_LOGIC_SLICE_NAME,
  SOCIAL_CAMPAIGN_IDENTITIES_INITIAL_STATE,
};
